const socialLinks = [

  {
    name: 'telegram',
    url: 'https://t.me/cregen',
    icon: '/static/images/personalSocials/telegram.svg',
  },
  {
    name: 'X',
    url: 'https://x.com/cregen_official?s=21',
    icon: '/static/images/personalSocials/x.svg',
  },
  {
    name: 'Linkedin',
    url: 'https://www.linkedin.com/company/cregen/',
    icon: '/static/images/personalSocials/Linkedin.svg',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/cregen_official/?igsh=MXl6bWZkZnU0MTg2&utm_source=qr',
    icon: '/static/images/personalSocials/Instagram.svg',
  },
];

const TeamWork = () => {
  return (
    <div className="flex flex-col items-center bg-black text-white py-16">
      <h1 className="text-4xl font-bold mb-2">TEAMWORK</h1>
      <p className="text-base font-light mb-8">BRAINS. PASSION. POWER. THIS IS US.</p>
      <div className="flex flex-col items-center">
        <div className="flex justify-center w-[248px] h-[328px] items-center mt-8">
          <img src="/static/images/teamwork/rade.png" alt="Rade Dimitrijevic" className="w-full h-full mb-4" />
        </div>
        <h2 className="text-xl font-semibold text-[#22C8BF] mt-10">Rade Dimitrijevic</h2>
        <dv className="w-full mt-4 flex justify-between items-center">
          <p className="text-sm mb-4 max-w-[180px]">Cregen senior tech lead and representatives</p>
          <img src="/static/images/favicon.png" alt="Cgen" className="w-[18px] h-[22px]" />
        </dv>
        <div className="w-full flex justify-between items-center h-[1px] bg-[#22C8BF] mt-2" />
        <div className="flex gap-4 mt-4">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              className="text-white hover:text-[#22C8BF] transition-colors duration-300" rel="noreferrer"
            >
              <img src={social.icon} alt={social.name} className="w-6 h-6" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TeamWork;
